<template lang="html">
  <div>
    <locations-item v-model="selectedItemId" />
    <v-card
      v-if="!showItemOnly"
      :key="instanceKey"
    >
      <page-bar
        :title="pageTitle"
        :context-menu="defaultContextMenu"
        :loading="isDataLoading"
      />

      <api-errors :errors="errors" />

      <!-- LIST OF ITEMS -->
      <item-select-table
        :add-action="addNewItem"
        :add-label="'Add ' + type"
        :edit-action="editItem"
        :loading="!!isLoading"
        :search="true"
        :items="items"
        :pagination.sync="pagination"
        :total-items="totalListItems"
        :headers="headers"
      />
    </v-card>
  </div>
</template>

<script>
import {itemSelect} from '@/ft-vue-core'
import LocationsItem from './LocationsItem'

export default {
  name: 'LocationsList',
  components: {LocationsItem},
  mixins: [itemSelect],
  data: function () {
    return {
      type: 'Location',
      types: 'Locations',
      headers: [
        this.headerText('Location Name', 'name', true),
        this.headerText('Kitchen', 'kitchenName', true),
        this.headerText('Comments', 'notes', true),
        this.headerSwitch('Events Only', 'eventOnly'),
        this.headerInvertedSwitch('Active', 'disabled')
      ],
      apiRecordCommand: 'diningLocation'
    }
  },
  computed: {
  },
  methods: {
    listCommandFilter (command) {
      return this.addCommandParamArrayVal(command, 'include_fields', 'kitchenName')
    }
  }
}
</script>
